import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const ReleaseService = {
    getByRelease: async (projectId) => axios.get(API_URL + "/release/" + projectId).then(({data}) => data).catch((err) => { throw err }),
    getNewRelease: async (releaseId) => axios.get(API_URL + "/release/new/" + releaseId).then(({data}) => data).catch((err) => { throw err }),
    getProjectUsers: async () => axios.get(API_URL + "/release/project/users" ).then(({data}) => data).catch((err) => { throw err }),
    getVersions: async () => axios.get(API_URL + "/release/versions" ).then(({data}) => data).catch((err) => { throw err }),

    saveBatch: async (data) => {
        return axios.post(API_URL + "/release/save", data)
            .then(({data}) => data)
            .catch(err => {
                throw err
            });
    },

    saveNewRelease: async (data) => {
        return axios.post(API_URL + "/release/new/save", data)
            .then(({data}) => data)
            .catch(err => {
                throw err
            });
    },

    delete: async (id) => axios.delete(API_URL + "/release/destroy/" + id).then((data) => data).catch((err) => { throw err }),
};

export default ReleaseService;
